// extracted by mini-css-extract-plugin
export default {"mobile_row":"SeasonsTable_mobile_row__LxTge","mobile_row_field":"SeasonsTable_mobile_row_field__QHZFl"};